module.exports = __webpack_public_path__ + "img/PaymentStage.6b664a16.svg";